<div class="header-bar">
  <div class="header-left">
    <div class="header-text">Heat Map</div>

    <div class="divider"></div>
    <div class="dates">
      <div class="date start-date">
        <div class="text">Start</div>
        <button
          mat-button
          class="icon-btn"
          (click)="startDatePicker.openPicker()"
        >
          <svg-icon
            src="assets/svg/calendar.svg"
            [svgStyle]="{
              'width.px': '26.5',
              'height.px': '26.5'
            }"
            svgClass="grey"
          >
          </svg-icon>
        </button>
        <lhpe-datepicker
          #startDatePicker
          [hideToggle]="true"
          placeholder="mm/dd/yyyy"
          [formGroup]="filterForm"
          controlName="startDate"
        >
        </lhpe-datepicker>
      </div>
      <div class="date end-date">
        <div class="text">End</div>
        <button
          mat-button
          class="icon-btn"
          (click)="endDatePicker.openPicker()"
        >
          <svg-icon
            src="assets/svg/calendar.svg"
            [svgStyle]="{
              'width.px': '26.5',
              'height.px': '26.5'
            }"
            svgClass="grey"
          >
          </svg-icon>
        </button>
        <lhpe-datepicker
          #endDatePicker
          [hideToggle]="true"
          placeholder="mm/dd/yyyy"
          [formGroup]="filterForm"
          controlName="endDate"
        >
        </lhpe-datepicker>
      </div>
    </div>
    <!-- <div class="divider"></div>
      <div class="filter">
        <button mat-button class="icon-btn" (click)="toggleFilterDialog()">
          <svg-icon src="assets/svg/filter.svg" svgClass="grey"></svg-icon>
        </button>
      </div> -->
  </div>
  <div class="header-center"></div>
  <div class="header-right"></div>
</div>
<div class="heat-map">
  <div class="container">
    <div class="container-content">
      <google-map #googleMap [options]="mapOptions"></google-map>
    </div>
  </div>
</div>
